module.exports = __webpack_public_path__ + "img/start-paly.07df8ad8.svg";